//#region Imports
import { CONTACT_INFORMATION_VALIDATIONS, NOT_APPLICABLE, NO_SYMBOLS_OR_SPACES_PATTERN, PAGES_ROUTES, PHONE_FORMAT, SURVEYSTEPS_INDEX } from '@app/member-response-portal/model/constants';
import { Component, OnInit } from '@angular/core';
import { ContactInformationDto } from '@app/member-response-portal/model/contactInformationDto';
import { EmploymentStatusDto } from '@app/member-response-portal/model/employmentStatusDto';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GenericMemberResponsePortalResponseDto } from '@app/core/models/genericMembeResponsePortalResponseDto';
import { Helper } from '@rawlings/core';
import { MedicareDto } from '@app/member-response-portal/model/medicareDto';
import { MemberResponseHelper } from '@app/member-response-portal/shared/member-response-helper';
import { MemberResponsePortalResponseDto } from './../../../core/models/memberResponsePortalResponseDto';
import { NavigationService } from '@app/member-response-portal/service/navigation.service';
import { NotificationRequestService } from '@app/member-response-portal/service/notification-request.service';
import { Observable, catchError, map, of } from 'rxjs';
import { OtherBenefitsDto } from '@app/member-response-portal/model/otherBenefitsDto';
import { OtherHealthInsuranceDto } from '@app/member-response-portal/model/otherHealthInsuranceDto';
import { PolicyHolderDto } from '@app/member-response-portal/model/policyHolderDto';
import { SharedMemberResponseService } from '@app/member-response-portal/service/shared-member-response.service';
import { SocialSecurityBenefitsDto } from './../../model/socialSecurityBenefitsDto';
import { SubmitSurveyRequestDto } from '@app/member-response-portal/model/submitSurveyRequestDto';
import { SummaryService } from '@app/member-response-portal/service/summary.service';
import { SurveyOtherHealthInsuranceHelper } from '@app/member-response-portal/shared/survey-other-health-insurance-helper';
import { SurveySummaryDto } from '@app/member-response-portal/model/surveySummaryDto';
import { SurveyResponseDto } from '@app/member-response-portal/model/surveyResponseDto';
//#endregion Imports

@Component({
    selector: 'app-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent implements OnInit {
    //#region Public Variables
    public ActiveStep: boolean = false;
    public ContactForm!: FormGroup;
    public EmploymentStatusForm!: FormGroup;
    public Form!: FormGroup;
    public MedicareForm!: FormGroup;
    public OHIData: OtherHealthInsuranceDto;
    public OtherBenefitForm!: FormGroup;
    public PhoneFormat: string = PHONE_FORMAT;
    public PolicyHolders: PolicyHolderDto[] =[];
    public SELF: string = 'Self'
    public SocialSecurityBenefitForm!: FormGroup;
    public SPOUSE: string = 'Spouse';
    public StepIndex: number = SURVEYSTEPS_INDEX.SUMMARY;
    public SummaryDto: SurveySummaryDto;
    public SurveyResponseDto: SurveyResponseDto;
    public Title: string = 'Summary';
    public NameMaxLength: number = CONTACT_INFORMATION_VALIDATIONS.USERNAME_MAX_LENGTH;
    public EmailMaxLength: number = CONTACT_INFORMATION_VALIDATIONS.EMAIL_MAX_LENGTH;
    //#endregion Public Variables

    //#region Properties

    public get CurrentlyWorking(): boolean{
        return this.EmploymentStatusForm.get('IsCurrentlyWorking').value;
    }

    public get Date(): FormControl {
        return this.ContactForm.get('ContactDate') as FormControl;
    }

    public get DayTimePhone(): FormControl {
        return this.ContactForm.get('DayTimePhone') as FormControl;
    }

    public get Email(): FormControl {
        return this.ContactForm.get('Email') as FormControl;
    }

    public get FormIsValid(): boolean {
        return this.ContactForm?.valid;
    }

    public get IsAcknowledge(): FormControl {
        return this.ContactForm.get('IsAcknowledge') as FormControl;
    }

    public get IsSigned(): FormControl {
        return this.ContactForm.get('IsSigned') as FormControl;
    }

    public get SpouseCurrentlyWorking(): FormControl {
        return this.EmploymentStatusForm.get('SpouseIsCurrentlyWorking') as FormControl;
    }

    public get ShowSpouseCurrentlyWorking(): boolean {
        return !Helper.IsEmpty(this.EmploymentStatusForm.get('HasSpouse').value);
    }

    public get Username(): FormControl {
        return this.ContactForm.get('Name') as FormControl;
    }
    //#endregion Properties

    //#region Constructor
    constructor(private fb: FormBuilder,
        private sharedService: SharedMemberResponseService,
        private summaryService : SummaryService,
        private navigationService : NavigationService,
        private notificationRequestService: NotificationRequestService){}

        public LoadData() : void {
            this.SummaryDto = this.sharedService.GetSurveySummary();
            this.SurveyResponseDto = this.sharedService.GetSurveyResponse();

            this.initializeForm();
        }

        public ngOnInit(): void {
            this.LoadData();
        }

        public OnSubmit(isSubmit: boolean = true): Observable<boolean> {
            const contactInformationDto: ContactInformationDto = {
                SurveyResponseId: this.sharedService.GetSurveyResponseId() || 0,
                Username: this.Username.value,
                DayTimePhone: this.DayTimePhone.value || '',
                Email: this.Email.value || '',
                IsAcknowledge: this.IsAcknowledge.value || false,
                IsSigned: this.IsSigned.value || false,
                Date: this.Date.value || '',
                QueueLetterId: this.sharedService.GetQueueLetterId() || 0
            }

            const submitSummaryRequestDto : SubmitSurveyRequestDto = {
                QueueLetterId: this.sharedService.GetQueueLetterId(),
                SurveyResponseId: this.sharedService.GetSurveyResponseId(),
                ResponseAttachmentId: null,
                ContactInformation: contactInformationDto,
                IsSubmit: isSubmit
            };

            return this.summaryService.Save(submitSummaryRequestDto).pipe(
                map(
                    (
                        result: GenericMemberResponsePortalResponseDto<MemberResponsePortalResponseDto>
                    ): boolean => {
                        if (result.Success) {
                            if(result.IsSurveySubmitted){
                                this.navigationService.NavigateTo(PAGES_ROUTES.CONFIRMATION);
                            }
                            return true;
                        } else {
                            result.IsSurveySubmitted ? this.notificationRequestService.ShowFailedRequestAndLogout(result) : this.notificationRequestService.ShowFailedRequestAndLogout(null);
                            return false;
                        }
                    }
                ),
                catchError(() => {
                    return of(false);
                })
            );
        }
        //#endregion Constructor and Angular Life Cycle

        //#region Public Methods
        public SetErrorTooltipMessage(value: string, message: string) : string {
            if (this.ContactForm.get(value).hasError('pattern')) {
                return `Invalid ${message}`;
            }

            return null;
        }
        //#endregion Public Methods

        //#region Private Methods
        private createContactFormGroup(surveyResponseDto: SurveyResponseDto): FormGroup {
            return this.fb.group({
                Name:[surveyResponseDto.Username || '', [Validators.required, Validators.pattern(NO_SYMBOLS_OR_SPACES_PATTERN)]],
                ContactDate:[{ value: surveyResponseDto.Date || '', disabled: true}],
                DayTimePhone:[surveyResponseDto.DayTimePhone || '', Validators.required],
                Email:[surveyResponseDto.Email || '', [Validators.required, Validators.email, Validators.pattern(Helper.RegExEmailExpression)]],
                IsAcknowledge:[surveyResponseDto.IsAcknowledge || false, Validators.requiredTrue],
                IsSigned:[surveyResponseDto.IsSigned || false, Validators.requiredTrue],
            })
        }

        private createEmploymentStatusFormGroup(employmentStatusDto: EmploymentStatusDto) : FormGroup {
            return this.fb.group({
                SurveyResponseId: [employmentStatusDto.SurveyResponseId || 0],
                IsCurrentlyWorking: [{value:employmentStatusDto.IsCurrentlyWorking || 0, disabled: true}],
                Name: [{value: employmentStatusDto.Name || '', disabled: true}],
                EmployerName: [{value: employmentStatusDto.CurrentEmployerName ?? employmentStatusDto.FormerEmployerName, disabled: true}],
                EmployerPhone: [{value: employmentStatusDto.CurrentEmployerPhone ?? employmentStatusDto.FormerEmployerPhone, disabled: true}],
                DateLastWorked: [{value: employmentStatusDto.DateLastWorked || '', disabled: true}],
                SpouseIsCurrentlyWorking: [{value: employmentStatusDto.HasSpouse ? MemberResponseHelper.GetStringToggleValue(employmentStatusDto.SpouseIsCurrentlyWorking) : NOT_APPLICABLE, disabled: true}],
                SpouseName: [{value: employmentStatusDto.SpouseName || '', disabled: true}],
                SpouseEmployerName: [{value: employmentStatusDto.SpouseCurrentEmployerName ?? employmentStatusDto.SpouseFormerEmployerName, disabled: true}],
                SpouseEmployerPhone: [{value: employmentStatusDto.SpouseCurrentEmployerPhone ?? employmentStatusDto.SpouseFormerEmployerPhone, disabled: true}],
                SpouseDateLastWorked: [{value: employmentStatusDto.SpouseDateLastWorked || null, disabled: true}],
                IsCompleted: [{value: employmentStatusDto.IsCompleted || null, disabled: true}],
                HasSpouse: [{value: employmentStatusDto.HasSpouse || null, disabled: true}],
            });
        }

        private createOtherBenefitFormGroup(otherBenefitDto: OtherBenefitsDto) : FormGroup{
            return this.fb.group({
                SurveyResponseId: [{value : otherBenefitDto.SurveyResponseId || 0, disabled : true}],
                ReceivingOtherBenefits: [{value :MemberResponseHelper.GetStringToggleValue(otherBenefitDto.ReceivingOtherBenefits) || null, disabled : true}],
                HasSpouseReceivingOtherBenefits: [{value :otherBenefitDto.HasSpouseReceivingOtherBenefits || null, disabled : true}],
                SpouseReceivingOtherBenefits: [{value :otherBenefitDto.SpouseReceivingOtherBenefits ? MemberResponseHelper.GetStringToggleValue(otherBenefitDto.SpouseReceivingOtherBenefits) : NOT_APPLICABLE, disabled : true}],
                RetireePlan: [{value :otherBenefitDto.RetireePlan || null, disabled : true}],
                COBRAContinuationOfCoverage: [{value :otherBenefitDto.COBRAContinuationOfCoverage || null, disabled : true}],
                ShortTermDisability: [{value :otherBenefitDto.ShortTermDisability || null, disabled : true}],
                LongTermDisability: [{value :otherBenefitDto.LongTermDisability || null, disabled : true}],
                WorkersCompensation: [{value :otherBenefitDto.WorkersCompensation ||  null, disabled : true}],
                SpouseRetireePlan: [{value :otherBenefitDto.SpouseRetireePlan || null, disabled : true}],
                SpouseCOBRAContinuationOfCoverage: [{value :otherBenefitDto.SpouseCOBRAContinuationOfCoverage || null, disabled : true}],
                SpouseShortTermDisability: [{value :otherBenefitDto.SpouseShortTermDisability || null, disabled : true}],
                SpouseLongTermDisability: [{value :otherBenefitDto.SpouseLongTermDisability || null, disabled : true}],
                SpouseWorkersCompensation: [{value :otherBenefitDto.SpouseWorkersCompensation || null, disabled : true}],
            });
        }

        private createSSBFormGroup(socialSecurityBenefitsDto: SocialSecurityBenefitsDto) : FormGroup {
            return this.fb.group({
                SocialSecurityBenefitsId: [socialSecurityBenefitsDto.SocialSecurityBenefitsId || 0],
                SurveyResponseId: [socialSecurityBenefitsDto.SurveyResponseId || 0],
                HasReceivedSocialSecurityBenefits: [{value: MemberResponseHelper.GetStringToggleValue(socialSecurityBenefitsDto.HasReceivedSocialSecurityBenefits) || null, disabled: true}],
                DateOfApplication: [{value: socialSecurityBenefitsDto.DateOfApplication || null, disabled: true}],
                IsSpouseReceivingSocialSecurityBenefits: [{value: MemberResponseHelper.GetStringToggleValue(socialSecurityBenefitsDto.IsSpouseReceivingSocialSecurityBenefits) || NOT_APPLICABLE, disabled: true}],
                SpouseDateOfApplication: [{value: socialSecurityBenefitsDto.SpouseDateOfApplication || null, disabled: true}],
                IsCompleted: [{value: socialSecurityBenefitsDto.IsCompleted || null, disabled: true}],
            });
        }

        private initializeForm() : void {
            if(!Helper.IsEmpty(this.SummaryDto)){
                if (!Helper.IsEmpty(this.SummaryDto.OtherHealthInsurance)) {
                    this.OHIData = this.SummaryDto.OtherHealthInsurance;
                    this.PolicyHolders = this.OHIData.PolicyHolders;

                    const medicareDto: MedicareDto = this.mapMedicareDto();
                    this.MedicareForm =
                    SurveyOtherHealthInsuranceHelper.CreateMedicareFormGroup(
                        medicareDto
                    );
                }

                if (!Helper.IsEmpty(this.SummaryDto.SocialSecurityBenefits)) {
                    this.SocialSecurityBenefitForm = this.createSSBFormGroup(
                        this.SummaryDto.SocialSecurityBenefits
                    );
                }

                if (!Helper.IsEmpty(this.SummaryDto.EmploymentStatus)) {
                    this.EmploymentStatusForm = this.createEmploymentStatusFormGroup(
                        this.SummaryDto.EmploymentStatus
                    );
                }

                if (!Helper.IsEmpty(this.SummaryDto.OtherBenefits)) {
                    this.OtherBenefitForm = this.createOtherBenefitFormGroup(
                        this.SummaryDto.OtherBenefits
                    );
                }
            }

            if(!Helper.IsEmpty(this.SurveyResponseDto)){
                this.ContactForm = this.createContactFormGroup(this.SurveyResponseDto);
            }
        }



        private mapMedicareDto() : MedicareDto {
            return {
                InsuranceNameBeneficiary : this.OHIData?.InsuranceNameBeneficiary || '',
                InsuranceMedicareId : this.OHIData?.InsuranceMedicareId || '',
                InsuranceEffectiveDateHospital : this.OHIData?.InsuranceEffectiveDateHospital || null,
                InsuranceEffectiveDateMedical : this.OHIData?.InsuranceEffectiveDateMedical || null,
            }
        }
        //#endregion Private Methods
    }
